<div class="dialogMain">
  <p mat-dialog-title class="dialogTitle">DELETING DEVICES</p>
  <div mat-dialog-content>
    <p class="dialogText">Data will be lost. This action cannot be undone.</p>
    <p class="dialogText">Do you want to continue ?</p>
  </div>
  <div>
    <button mat-button [mat-dialog-close]="false" class="dialogLogoutBtnNo">
      <mat-icon class="dialogIconNo">close</mat-icon> NO
    </button>
    <button mat-button [mat-dialog-close]="true" class="dialogLogoutBtnYes">
      YES <mat-icon class="dialogIconYes">check</mat-icon>
    </button>
  </div>
</div>
